/* eslint-disable camelcase */
import axios from 'axios';
import _get from 'lodash/get';
import _chunk from 'lodash/chunk';
import _isEmpty from 'lodash/isEmpty';
import { GIFT_TABLE_ROOT as ROOT, BASE_PATH_API } from 'constants/env';
import {
  DESKTOP_PAGE,
  DESKTOP_SIZE,
  MOBILE_PAGE,
  MOBILE_SIZE,
} from 'constants/values/params';
import { getProductsById, mapProductData } from 'services/api/products';
import { getPaginationProps } from 'util/calculations';
import { isMobile } from 'util/screen';
import {
  dynamicConfigurationTransformer,
  rulesTransformer,
} from './transformers';

const LIMIT = 20;

export const getRecommendationTypes = async () => {
  const url = `${BASE_PATH_API}/${ROOT}/recommendation-type`;
  const res = await axios({ url });
  return res.data;
};

export const getProductsByRecommendation = async (eventId) => {
  const url = `${BASE_PATH_API}/${ROOT}/configuration-recommendation-product/${eventId}`;
  const res = await axios({ url });
  const { categorias = [], productsAll = [] } = res.data.data;
  return [categorias, productsAll];
};

export const getProductsByCategory = async (
  { products = [] },
  {
    page = 1,
    size = 12,
    mobilePage = MOBILE_PAGE,
    mobileSize = MOBILE_SIZE,
    withPagination = true,
  } = {},
  { variants = [] } = [],
  { isExternal = false }
) => {
  const allProductIds = products.map((g) => g);

  const chunkAllProductIds = _chunk(allProductIds, LIMIT);

  const listProductData = await Promise.all(
    chunkAllProductIds.map((list) => getProductsById(list))
  );

  // eslint-disable-next-line prefer-spread
  const productsData = [].concat.apply([], listProductData);

  const data = productsData.map(p => p.data);

  //const response = await getProductsById(products);

  const response = {
    data: isExternal
      ? [].concat.apply([], data)
      : [].concat.apply([], data.reverse()).reverse()
  }

  const duplicateProducts = {};
  products.forEach(function (x) { duplicateProducts[x] = (duplicateProducts[x] || 0) + 1; });

  for(const key in duplicateProducts) {
    if(+duplicateProducts[key] > 1) {
      const itemWithOutClone = JSON.parse(JSON.stringify(response.data));
      const newItem = itemWithOutClone.filter(p => +p.id == +key);
      newItem.length && response.data.push(newItem[0]);
    }
  }

  // This is only for know variant in AddToCart (External GiftTable)
  if(variants.length) {
    response.data?.map(r => {
      const variant = r.variations?.filter(v => variants.includes(v.id));
      r.variant_id = variant?.length ? variant[0].id : null;
      r.variant_sku = variant?.length ? variant[0].sku : null;
      r.stock = variant?.length ? variant[0].stock : r.stock;
      if(variant?.length) variants = variants.filter(v => +v != +variant[0].id);
    });
  }

  const productVariants = response.data.map(pv => {
    return {
      id: pv.id,
      variant: pv.variant_id
    }
  });

  const transformedProducts = response.data?.map(mapProductData);
  const orderProductsEqualToOriginalList = productVariants
    .map((product) => {
      const findProduct = transformedProducts?.find((prod) => {
        if(prod.id == product.id && prod.variant_id == product.variant) {
          const ids = [prod.id, prod.product_id, prod.item];
          return ids.find((id) => Number(id) === Number(product.id));
        }
      });

      return findProduct;
    })
    .filter(Boolean);

  return withPagination
    ? getPaginationProps(
        orderProductsEqualToOriginalList,
        size,
        page,
        mobileSize,
        mobilePage
      )
    : orderProductsEqualToOriginalList;
};

export const getDynamicRecommendation = async (eventTypeId, guestRangeId) => {
  const url = `${BASE_PATH_API}/${ROOT}/configuration-recommendation-dynamic/${eventTypeId}`;
  const res = await axios({ url });
  const recommendationRules = await getRulesRecommendationCatalog();
  const transformedRules = rulesTransformer(recommendationRules);
  const { configurations = [], event_type_id } = res.data.data;

  const transformedConfigurations = dynamicConfigurationTransformer(
    configurations,
    transformedRules,
    guestRangeId
  );

  const dynamicRecommendation = {
    configurations: transformedConfigurations,
    eventTypeId: event_type_id,
  };

  return [dynamicRecommendation, transformedRules];
};

export const getRulesRecommendationCatalog = async () => {
  const url = `${BASE_PATH_API}/${ROOT}/recommendation-rules-catalog`;
  const res = await axios({ url });
  return res.data.data;
};

export const getStaticProducts = async ({
  state,
  products,
  cleanParams = false,
  ...restParams
} = {}) => {
  const allProducts =
    products ||
    _get(state, 'gifts.productsByRecommendations.data.allProducts', []);

  const params = _isEmpty(restParams)
    ? _get(state, 'gifts.listOfGifts.params', {})
    : restParams;

  const size = cleanParams ? DESKTOP_SIZE : _get(params, 'size', DESKTOP_SIZE);
  const page = cleanParams ? DESKTOP_PAGE : _get(params, 'page', DESKTOP_PAGE);
  const mobileSize = cleanParams
    ? MOBILE_SIZE
    : _get(params, 'mobileSize', MOBILE_SIZE);
  const mobilePage = cleanParams
    ? MOBILE_PAGE
    : _get(params, 'mobilePage', MOBILE_PAGE);

  const paginationProps = getPaginationProps(
    allProducts,
    size,
    page,
    mobileSize,
    mobilePage
  );

  const productsParams = {
    size,
    page: 1,
    mobileSize,
    mobilePage,
  };

  const productsToFetch = isMobile()
    ? paginationProps.mobileList
    : paginationProps.list;

  const { list, mobileList } = await getProductsByCategory(
    { products: productsToFetch },
    productsParams
  );

  paginationProps.list = list;
  paginationProps.mobileList = mobileList;
  paginationProps.allElements = isMobile() ? mobileList : list;

  return paginationProps;
};
